import React, { useState, useEffect } from 'react';
import Heading from '../../../component/Heading/Heading';
import "../../../styles/pages/customer/stammdaten.scss";
import { Autocomplete, FormControl, FormHelperText, FormLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { MenuProps, StammdatenData } from '../../../content/content';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StammdatenTable from './StammdatenTable.jsx';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/de';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { getCustomerStammdaten } from '../../../services/customer-services/customerStammdatenService';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

function Stammdaten() {
    const { t } = useTranslation();
    const [stammdatenErrors, setStammdatenErrors] = useState({});
    const [stammdaten, setStammdaten] = useState({});
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0);

    const handleStammdatenChange = (e, newValue) => {
        const { name, value } = e.target || {};

        if (name) {
            setStammdaten((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleBranche = (e, newValue) => {
        setStammdaten((prevState) => ({
            ...prevState,
            ["branche"]: newValue?.value,
        }));
    }

    const handleDateChange = (newValue) => {
        setStammdaten((prevState) => ({
            ...prevState,
            grundungjahr: newValue,
        }));
        
    };

    const getAllCustomerStammdaten = async () => {
        const response = await getCustomerStammdaten({ pageNo, perPage });
        if (response?.isSuccess) {
            if (response.customerStammdaten?.grundungjahr) {
                response.customerStammdaten.grundungjahr = dayjs(response.customerStammdaten.grundungjahr);
            }
            setTotalRecords(response?.totalRecord)
            setStammdaten(response?.customerStammdaten || {});
        }
    };

    useEffect(() => {
        getAllCustomerStammdaten();
    }, [pageNo, perPage]);

    return (
        <div className="stammdatenverwaltung">
            <div>
                <Heading text={t('stammdaten_heading')} />
                <div className="stammdatenverwaltung-border">
                    <h3 className="sub-heading">{t("stammdaten_unternehmensdaten")}</h3>
                    <Grid container columnSpacing={5} rowSpacing={2}>
                        {StammdatenData?.map((item, index) => (
                            <Grid item size={{ xs: 12, md: 6, lg: 6 }} key={index} className="select-label">
                                {item.label === "Branche" && item.type === "select" ?
                                    (
                                        <FormControl fullWidth error={!!stammdatenErrors[item.name]}>
                                            <FormLabel
                                                className="label"
                                                sx={{
                                                    paddingTop: "1.25rem",
                                                    paddingBottom: "10px",
                                                    display: "inline-block",
                                                    color: "#000",
                                                }}
                                            >
                                                {t(item.translationKey)}
                                            </FormLabel>
                                            <Autocomplete
                                                onChange={handleBranche}
                                                options={item?.options}
                                                getOptionLabel={(option) => t(option.translationKey)}
                                                popupIcon={<ExpandMoreIcon sx={{ fontSize: "30px", color: "#33333399" }} />}
                                                value={item?.options.find(opt => opt.value === stammdaten[item?.name]) || ""}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "10px",
                                                        border: "1px solid rgba(227, 227, 227, 0.57)"
                                                    },
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        name={item?.name}
                                                        placeholder={t('stammdaten_placeholder_branche')}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
                                                                padding: 0
                                                            }
                                                        }} />}
                                            />
                                            {stammdatenErrors[item.name] && (
                                                <FormHelperText
                                                    sx={{
                                                        color: "#d32f2f",
                                                        margin: "5px 0 0 0 ",
                                                        fontSize: "14px",
                                                        fontFamily: "Poppins"
                                                    }}
                                                >
                                                    {stammdatenErrors[item.name]}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    ) : item.type === "select" ? (
                                        <FormControl fullWidth error={!!stammdatenErrors[item.name]}>
                                            <FormLabel
                                                className="label"
                                                sx={{
                                                    paddingTop: "1.25rem",
                                                    paddingBottom: "10px",
                                                    display: "inline-block",
                                                    color: "#000",
                                                }}
                                            >
                                                {t(item.translationKey)}
                                            </FormLabel>
                                            <Select
                                                className="select-input"
                                                fullWidth
                                                value={stammdaten[item?.name] || ""}
                                                onChange={handleStammdatenChange}
                                                displayEmpty
                                                sx={{
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '10px',
                                                        fontSize: '16px',
                                                    },
                                                }}
                                                inputProps={{
                                                    name: item?.name,
                                                    IconComponent: () => (
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                paddingRight: "10px",
                                                            }}
                                                        >
                                                            <ExpandMoreIcon sx={{ fontSize: "30px", color: "#33333399" }} />
                                                        </span>
                                                    ),
                                                }}
                                                style={{
                                                    padding: "0",
                                                    borderRadius: "10px",
                                                    border: "1px solid #e3e3e391",
                                                }}
                                                disabled={item?.name === "year"}
                                                MenuProps={MenuProps}
                                            >
                                                <MenuItem value="" disabled>
                                                    {t(item.placeholderTranslationKey)}
                                                </MenuItem>
                                                {item?.options?.map((option, i) => (
                                                    <MenuItem key={i} value={option.value} disabled={option.value === "2023"}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {stammdatenErrors[item.name] && (
                                                <FormHelperText
                                                    sx={{
                                                        color: "#d32f2f",
                                                        margin: "5px 0 0 0 ",
                                                        fontSize: "14px",
                                                        fontFamily: "Poppins"
                                                    }}
                                                >
                                                    {stammdatenErrors[item.name]}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    ) : item.type === "date" && (
                                        <div className="stammdaten-datepicker">
                                            <DemoContainer components={['DateField', 'DateField']}>
                                                <LocalizationProvider
                                                    dateAdapter={AdapterDayjs}
                                                    adapterLocale="de"
                                                    localeText={{
                                                        field: { datePlaceholder: t(item.placeholderTranslationKey) },
                                                    }}
                                                >
                                                    <DemoItem  >
                                                        <Typography htmlFor="" className='grundungjahr-label' >{t(item.translationKey)}</Typography>
                                                        <DateField
                                                            value={stammdaten?.grundungjahr || null}
                                                            name="grundungjahr"
                                                            onChange={handleDateChange}
                                                            format="DD.MM.YYYY"
                                                            error={!!stammdatenErrors["grundungjahr"]}
                                                            helperText={stammdatenErrors["grundungjahr"] || ""}
                                                            FormHelperTextProps={{
                                                                sx: {
                                                                    color: !!stammdatenErrors["grundungjahr"] ? "#d32f2f" : "#14A9E2",
                                                                    margin: "5px 0 0 0 ",
                                                                    fontSize: "14px",
                                                                    fontFamily: "Poppins"
                                                                },
                                                            }}
                                                            sx={{
                                                                '& input::placeholder': {
                                                                    color: '#000 !important',
                                                                    fontSize: '16px important',
                                                                    opacity: "1 !important",
                                                                    fontFamily: "Poppins",

                                                                },
                                                                '& input': {
                                                                    padding: "9px",
                                                                    borderRadius: "10px"
                                                                },
                                                            }}

                                                        />
                                                    </DemoItem>
                                                </LocalizationProvider>
                                            </DemoContainer>
                                        </div>
                                    )}
                            </Grid>
                        ))}
                    </Grid>
                    <StammdatenTable stammdatenData={stammdaten} setStammdaten={setStammdaten} totalRecords={totalRecords} setPageNo={setPageNo} setPerPage={setPerPage} pageNo={pageNo} perPage={perPage} setStammdatenErrors={setStammdatenErrors} getAllCustomerStammdaten={getAllCustomerStammdaten} />
                </div>
            </div>
        </div>
    );
}

export default Stammdaten;
